<template>
    <div class="page page__list">
        <search-bar @search="onSearch" name="ex_name" placeholder="请输入关键字搜索" ref="searchBar" />
        <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
        <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
            <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.id"
                :to="'/oa/exam/' + item.id">
                <div class="weui-cell__bd">
                    <p>{{ item.ex_code }}</p>
                </div>
                <div class="weui-cell__ft">
                    <p>{{ item.ex_name }}</p>
                    <span class="list-item-status" :class="{ 'warning': item.ex_status != '已审核' }">{{ item.ex_status
                        }}</span>
                </div>
            </router-link>
        </scroll-list>
        <div class="list-footer">
            <label class="list-footer__label">合计：{{ items.length }}场</label>
        </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
    components: {
        SearchBar,
        FilterBar,
        ScrollList
    },
    mixins: [list],
    data() {
        return {
            listUrl: "/api/oa/exam/list",
            filters: [
                {
                    type: "date",
                    name: "exam.createTime"
                },
                {
                    type: "condition",
                    label: "状态",
                    value: -1,
                    options: [
                        {
                            value: -1,
                            label: "全部"
                        },
                        {
                            value: 1,
                            label: "待审核",
                            condition: "ex_statuscode!='AUDITED'"
                        },
                        {
                            value: 2,
                            label: "已审核",
                            condition: "ex_statuscode='AUDITED'"
                        }
                    ]
                }
            ]
        };
    }
};
</script>